import { combineReducers } from 'redux';

import bookingsList from 'modules/bookings/redux/reducer';
import payment from 'modules/payment/redux/reducer';
import dac7 from 'modules/dac7/redux/reducers';
import reviews from 'modules/reviews/redux/reducer';
import tags from 'modules/tags/redux/reducer';
import complaints from 'modules/complaints/redux/reducer';
import flags from 'modules/flags/redux/reducer';
import hostFiles from 'modules/hostFiles/redux/reducer';

import bookings from './bookings';
import conversation from './conversation';
import conversations from './conversations';
import cottage from './cottage';
import cottages from './cottages';
import login from './login';
import modals from './modals';
import router from './router';
import user from './user';
import ui from './ui';
import scaVerification from './scaVerification';
import scaRecipientSync from './scaRecipientSync';
import scaResume from './scaResumeReducer';

export default combineReducers({
  bookings,
  conversation,
  conversations,
  cottage,
  cottages,
  login,
  modals,
  router,
  user,
  ui,
  scaVerification,
  scaRecipientSync,
  scaResume,

  bookingsList,
  complaints,
  payment,
  dac7,
  reviews,
  tags,
  flags,
  hostFiles,
});
